import { render, staticRenderFns } from "./DuesProject.vue?vue&type=template&id=0f0e8757&scoped=true&"
import script from "./DuesProject.vue?vue&type=script&lang=js&"
export * from "./DuesProject.vue?vue&type=script&lang=js&"
import style0 from "./DuesProject.vue?vue&type=style&index=0&id=0f0e8757&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0e8757",
  null
  
)

export default component.exports